import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import LoginBgImage from "../assets/login-bg.jpg";
import GirlImg from "../assets/girl.jpg";
import Logo from "../assets/logo.jpg";

const Login = ({ onLoginSuccess }) => {
    const [isForgot, setIsForgot] = useState(false);

    const [formData, setFormData] = useState({
        email: "",
        password: ""
    });

    const [errors, setErrors] = useState({});
    const navigate = useNavigate();
    const [role, setRole] = useState("student");

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));

        setErrors((prev) => ({
            ...prev,
            [name]: ""
        }));
    };

    const validateForm = () => {
        let newErrors = {};

        if (!formData.email) {
            newErrors.email = "Email is required";
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            newErrors.email = "Enter valid email";
        }

        if (!isForgot) {
            if (!formData.password) {
                newErrors.password = "Password is required";
            } else if (formData.password.length < 4) {
                newErrors.password = "Minimum 4 characters required";
            }
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!validateForm()) return;

        if (isForgot) {
            alert("Reset link sent to your email");
            setIsForgot(false);
            return;
        }

        // 🔥 Hardcoded login check
        if (
            formData.email === "admin@gmail.com" &&
            formData.password === "1234"
        ) {
            console.log("Login Success");

            // ✅ Safe call
            if (onLoginSuccess) {
                onLoginSuccess();
            }
        } else {
            setErrors({ password: "Invalid email or password" });
        }
    };

    return (

        <div className="login-page">

            <div className="login-header">
                <img src={Logo} alt="logo" className="logo" />
                <h2>Welcome to Sharada Hill Modern School</h2>
            </div>
            <div className="login-container">

                {/* LEFT SIDE (IMAGE / DESIGN) */}
                <div className="left-side">
                    <img src={LoginBgImage} alt="School" />
                </div>

                {/* RIGHT SIDE (FORM) */}
                <div className="right-side">
                    <img src={GirlImg} alt="girl" className="girl-image" />
                    {/* ✅ BACK BUTTON HERE */}
                    <button
                        className="back-btn"
                        onClick={() => navigate("/")}
                    >
                        ← Back
                    </button>

                    {/* Toggle Buttons */}
                    <div className="role-toggle">
                        <button
                            className={role === "student" ? "active" : ""}
                            onClick={() => setRole("student")}
                            type="button"
                        >
                            Student
                        </button>

                        <button
                            className={role === "teacher" ? "active" : ""}
                            onClick={() => setRole("teacher")}
                            type="button"
                        >
                            Teacher
                        </button>
                    </div>

                    <div className="login-box">

                        <h2>{isForgot ? "Forgot Password" : "LOG IN"}</h2>

                        <form onSubmit={handleSubmit}>
                            <input
                                type="email"
                                name="email"
                                placeholder="Email Address"
                                value={formData.email}
                                onChange={handleChange}
                                className={errors.email ? "error-input" : ""}
                            />
                            {errors.email && <p className="error">{errors.email}</p>}

                            {!isForgot && (
                                <>
                                    <input
                                        type="password"
                                        name="password"
                                        placeholder="Password"
                                        value={formData.password}
                                        onChange={handleChange}
                                        className={errors.password ? "error-input" : ""}
                                    />
                                    {errors.password && (
                                        <p className="error">{errors.password}</p>
                                    )}
                                </>
                            )}

                            {!isForgot && (
                                <p className="forgot" onClick={() => setIsForgot(true)}>
                                    Forgot Password?
                                </p>
                            )}

                            <button type="submit">
                                {isForgot ? "Send Reset Link" : "Log in"}
                            </button>
                            <button className="back-btn" onClick={() => navigate("/")}>
                                ← Back
                            </button>
                        </form>
                    </div>
                </div>
            </div>


            <style>{`
        .login-page {
          height: 100vh;
          display: flex;
          justify-content: center;
          align-items: center;
          background: rgba(227,227,227,1);
          font-family: Arial, sans-serif;
        }
          .login-header {
          position: absolute;
          top: 50px;
          left: 50%;
          transform: translateX(-50%);
          display: flex;
          align-items: center;
          gap: 12px;
          }

.login-header h2 {
  font-size: 28px;
  color: #2f66b1;
  margin: 0;
}

.logo {
  height: 45px;
  width: 55px;
  object-fit: contain;
}
          .login-card {
          position: relative;
          background: #f0f0f0;
          padding: 40px 30px;
          width: 350px;
          border-radius: 10px;
          box-shadow: 0 10px 25px rgba(0,0,0,0.2);
          text-align: center;
          }

        input {
          width: 100%;
          padding: 12px;
          margin-bottom: 10px;
          border-radius: 6px;
          border: 1px solid #ccc;
        }

        .error-input {
          border: 1px solid red;
        }

        .error {
          color: red;
          font-size: 12px;
          text-align: left;
        }
          .forgot {
  text-align: right;
  cursor: pointer;
  color: #5f5fff;
  font-size: 12px;
  margin-bottom: 10px;

  /* ✅ ensure it's above anything */
  position: relative;
  z-index: 20;
}

        button {
          width: 100%;
          padding: 12px;
          background: #2f66b1;
          color: white;
          border: none;
          border-radius: 6px;
          cursor: pointer;
        }
          .login-container {
          width: 850px;
          height: 450px;
          display: flex;
          border-radius: 15px;
          overflow: hidden;
          box-shadow: 0 15px 40px rgba(0,0,0,0.2)
          }
          
          /* LEFT SIDE */
          .left-side {
          width: 50%;
          background: #f5f5f5;
          display: flex;
          justify-content: center;
          align-items: center;
          }
          .left-side img {
          width: 80%;
          }
          
          /* TOGGLE BUTTON */
          .role-toggle {
  display: flex;
  background: #eee;
  border-radius: 20px;
  overflow: hidden;
  width: fit-content;
  margin-bottom: 20px;
}

.role-toggle button {
  padding: 8px 20px;
  border: none;
  background: transparent;
  cursor: pointer;
  transition: 0.3s;
  color: #333;
}

/* ACTIVE BUTTON */
.role-toggle .active {
  background: linear-gradient(90deg, #5f5fff, #7a5cff);
  color: white;
  border-radius: 20px;
}

/* LOGIN BOX */
.login-box h2 {
  margin-bottom: 20px;
  color: #5f5fff;
}


button[type="submit"] {
  width: 100%;
  padding: 12px;
  background: linear-gradient(90deg, #5f5fff, #7a5cff);
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}
  .login-logo { 
  width: 100px; 
  height: auto;
  margin-bottom: 15px;
  } 

.right-side {
  width: 50%;
  background: white;
  padding: 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative; 
}
  .login-container {
  width: 850px;
  height: 450px;
  display: flex;
  border-radius: 15px;
  overflow: visible; /* IMPORTANT */
  box-shadow: 0 15px 40px rgba(0,0,0,0.2);
  position: relative; /* IMPORTANT */
}

/* GIRL IMAGE STYLE */
.girl-image {
  position: absolute;
  right: -135px;  
  bottom: 0;
  height: 380px;
  z-index: 10;
  pointer-events: none;
}

.back-btn {
  position: absolute;
  top: 10px;
  right: 15px;
  left: 140px; 
  background: transparent;
  border: none;
  color: #2f66b1;
  font-size: 14px;
  cursor: pointer;
  font-weight: bold;
}

.back-btn:hover {
  text-decoration: underline;
}
      `}</style>
        </div>
    );
};

export default Login;